import moment from 'moment';

const years = (back) => {
  const year = new Date().getFullYear();
  return Array.from({ length: back }, (v, i) => year - back + i + 1);
};

export const selectYears = years(moment().diff('2020-01-01', 'years') + 1);
export const selectMarcoArea = ['retail', 'food'];
